/** Prefix embedded in accounting comment text to freeze calc sum per comment. */
const CALC_AMOUNT_META_RE = /^\[\[calc_amount:(.+?)\]\]\n?/;

export const wrapCommentWithCalcAmount = (text: string, amountLabel: string): string => {
  const note = text.trim();
  const amount = amountLabel.trim();
  if (!note) return note;
  if (!amount) return note;
  return `[[calc_amount:${amount}]]\n${note}`;
};

export const parseCalcCommentText = (text: string): { amount: string | null; body: string } => {
  const raw = String(text ?? "");
  const match = raw.match(CALC_AMOUNT_META_RE);
  if (!match) return { amount: null, body: raw };
  return {
    amount: match[1]?.trim() || null,
    body: raw.slice(match[0].length),
  };
};

export const stripCalcCommentMeta = (text: string): string => parseCalcCommentText(text).body;
